import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { Card, Col, Container, Row, Spinner } from "reactstrap";
import { IoMdArrowBack } from "react-icons/io";
import { getEductions } from "store/actions/blogActions";
import { useLocation } from "react-router-dom/cjs/react-router-dom";

const Education = () => {
  const location = useLocation();

  let dispatch = useDispatch();
  const [dataLoader, setDataLoader] = useState(true);

  const { EductionVideos } = useSelector((state) => state.blog);

  useEffect(() => {
    dispatch(
      getEductions(() => {
        setDataLoader(false);
      })
    );
  }, [dispatch]);

  return (
    <>
      {location.pathname == "/talent-contest" && (
        <button type="button" className="text-white btn btn-primary mx-4 my-3" onClick={() => window.history.back()}>
          <IoMdArrowBack /> Go Back
        </button>
      )}
      <div className="my-4 text-center">
        <a
          href="https://youtu.be/ImQSgD1Y3EY
"
          target="_blank"
          rel="noopener noreferrer"
        >
          https://youtu.be/ImQSgD1Y3EY
        </a>
      </div>
      {/* <Card>
        <Container className="my-4 px-4">
          <h1 className="text-center my-3">Advancing Education for FHP</h1>
          {dataLoader ? (
            <div className="text-center">
              <Spinner color="primary" />
            </div>
          ) : (
            <Row className="button-container">
              {EductionVideos.map((e, index) => (
                <Col sm={4} className="button-container" key={index}>
                  <div className="tooltip-container">
                    <a
                      className="mt-4 text-white btn btn-primary my-1"
                      href={e.url}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fa fa-solid fa-play mr-2"></i>
                      {e.title.length > 21
                        ? e.title.slice(0, 22) + "..."
                        : e.title}
                    </a>
                    {e.title.length > 21 && (
                      <span className="tooltip-text">{e.title}</span>
                    )}
                  </div>
                </Col>
              ))}
            </Row>
          )}
        </Container>
      </Card> */}
    </>
  );
};

export default Education;
